import { gql } from "@apollo/client";

const UploadSubscription = gql`
  subscription UploadSubscription($topic: String!, $userId: UUID!) {
    listen(topic: $topic) {
      query {
        allUploads(condition: { userId: $userId }, orderBy: UPLOADED_DESC) {
          nodes {
            projectName
            imageCount
            id
            status
            uploaded
            zipFileName
            zipFileSize
            imageCount
            isBulk
            failedFilesByUploadId {
              totalCount
            }
          }
        }
      }
    }
  }
`;

const hash = "d7eefd10db027fb213afd142eaeddc8314b9855fecc350b80cae1897bab0e67a";

export { UploadSubscription, hash };
